export const environment = {
  production: false,
  appName: 'Arrendamiento Médico Test',
  apiURLNew: 'https://visitasdigitalesapi.test.einteligent.com',
  apiURLWebServices: 'https://app-citronella-demo-test.azurewebsites.net/WebServices',
  authToken:
    'KPA/tjqTnXgGxBRvoInn5Kh7/oRfTDWhQ/5uZgbDwzSKbSPqQb7UxmF3VSGwZKYBoBpYwuFKcR6PqoqrfbQrY2pz3fQuEkbMxIUaj7JsYp6MCc7/yW8siQ4A9TasU9YQ3xLyoSsMNG+JR0m30TB5eiNMMGMl9QF+enkCRnfY6HAKTz3qSK+cGHOjuWE7kls97nS83YQHj8x961I4ytxvIoiJlBr3hKVFhkOoreuSDmaydYZRGFLMLreP9YaEniGp2+OC4PGi+nuICeSJzkViKOz+qebksi/8L3g4EsIhpcPxrqjAv2O5mOQKxy/QU/pOskbmNUMBy2zWxmh/auisaSqiakJSENojfkLbDoYLlbw=',
  lenguage: 'es',
  arrayInputs: [
    'text-line',
    'reader-PDF',
    'break-line',
    'input-general',
    'button-general',
    'input-upload-ligh',
    'input-general-phone',
    'input-general-select',
    'input-general-number',
    'input-general-checkbox',
    'input-general-currency',
    'input-general-calendar',
    'input-general-text-area',
    'input-general-percentage',
    'input-general-autocomplete',
  ],
  arrayInputsTrasform: [
    'input-general',
    'input-general-phone',
    'input-general-select',
    'input-general-number',
    'input-general-currency',
    'input-general-calendar',
    'input-general-text-area',
    'input-general-percentage',
    'input-general-autocomplete',
  ],
};
